import { useQuery, UseQueryResult } from 'react-query';
import { AccountLink } from 'types';
import { client } from 'utils/api-client';

interface IUseAccountLink {
  type: 'account_onboarding' | 'account_update';
  // Defaults to enabled. Callers pass false to skip the request — the endpoint is owner-only,
  // so fetching it as a staff member only produces a 403.
  enabled?: boolean;
}

function useAccountLink({ type, enabled = true }: IUseAccountLink): UseQueryResult<{ data: AccountLink }> {
  return useQuery(['accountLink', type], () => client.get(`stripe/account-link/${type}`), { enabled });
}

export default useAccountLink;
